export default __webpack_public_path__ + "static/media/AvenirLTStd-Medium.e6420e70.otf";